import { Button, Typography, Space } from "antd";
import { useEffect, useState } from "react";
import FormSetup from "../../../components/Forms/FormSetup";
import { MasterConfigs } from "../../../interfaces/entity";
import { constants } from "../../../constants/common";
import ReusableTable from "../../../components/TableComponent";
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard";
import moment from "moment";
import { formatPriceIndian } from "../../../constants/functions";
import Badge from "../../../components/Badge";
import { useDispatch } from "react-redux";
import { putData } from "../../../actions/developer";
const { Title } = Typography;

interface ProjectsProps {
    refType: string;
    refId: string;
    highlighted: boolean;
}

const Projects: React.FC<ProjectsProps> = ({
    refType,
    refId,
    highlighted
}) => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const config: MasterConfigs = {
        api: () => `/deals/projects/list`,
        queryParams: {
            id: refId
        },
        title: "Projects",
        modalTitle: () => "Add Project",
        getColumns: () => [
            {
                title: "Project", dataIndex: "name", key: "name", render: (text, record) => (
                    text
                ),
                width: 200,
                fixed: 'left'
            },
            {
                title: 'Project Type',
                width: 150,
                align: 'center', dataIndex: 'projectType', key: 'projectType'
            }
        ],
        getFormColumns: () => [
            {
                label: 'Project Name',
                name: 'project',
                type: 'select',
                isCombo: true,
                span: 12,
                rules: [{ required: true, message: 'Project Name is required' }]
            }
        ],
        onSubmit: async (id, value) => {
            const resData = await updateData(id, value)
            return resData
        },
        combo: [
            {
                api: `/projects`,
                name: 'project',
                idKey: '_id',
                render: (text, record) => text.name
            }
        ]
    }

    const updateData = async (id, value) => {
        try {
            const response = await dispatch(putData(`/deals/${id}`, value));
            return response;
        } catch (error) {
            console.error("Error updating project:", error);
        }
    }

    return (
        <div >
            <div className="flex justify-between items-center py-2 px-4 border-b">
                <Title level={5} className={highlighted ? 'bg-yellow-200 px-1' : ''}>Projects</Title>
                <Button type="text" onClick={() => setOpen(true)}>Add Projects</Button>
            </div>
            <FormSetup isModal={true} open={open} config={config} onClose={() => setOpen(false)} id={refId} />
            <div className="p-4">
                <ReusableTable config={config} />
            </div>
        </div>
    );
}

export default Projects;